import React from 'react';
import moment from 'moment/moment';
import ReactiveTable from '../../Organisms/ReactiveTable/ReactiveTable';
import './DynastiesPage.scss';

const DynastiesPage = () => {
  const columns = [
    {
      name: 'Code',
      selector: row => row.code,
      sortable: true,
    },
    {
      name: 'Dynasty',
      selector: row => row.name,
      sortable: true,
    },
    {
      name: 'Created',
      selector: row => moment(row.created_at || row.updated_at).fromNow(),
      sortable: true,
    },
  ];
  return (
    <>
      <div className="col-md-12 header-container">
        <h2>Dynasties</h2>
      </div>
      <div className="col-md-12 content-container">
        <ReactiveTable
          columns={columns}
          endpoint="types/dynasties"
          exportableKeys={['name', 'code']}
          modalTitle="Dynasty"
          fields={['name', 'code']}
        />
      </div>
    </>
  );
};

export default DynastiesPage;
